import { createContext } from 'react';

const BeamContext = createContext(null);

export default BeamContext;
